/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReprogramarFechaModelDto } from '../../models/reprogramar-fecha-model-dto';

export interface CitasControllerReprogramarCita$Params {

/**
 * Código de la cita a modificar
 */
  uuidCita: string;

/**
 * Tipo de consulta de la cita a reprogramar
 */
  tipoConsulta?: 'PRESENCIAL' | 'TELEFONICA' | 'VIRTUAL';

/**
 * Tipo de cita a reprogramar
 */
  tipoCita?: 'MEDICA' | 'ANALITICA' | 'PRUEBA' | 'FARMACIA';

/**
 * Rango de fechas nueva de la cita a reprogramar
 */
  nuevaRangoCitaInicio?: string;

/**
 * Rango de fechas de la cita a reprogramar
 */
  nuevaRangoCitaFin?: string;
}

export function citasControllerReprogramarCita(http: HttpClient, rootUrl: string, params: CitasControllerReprogramarCita$Params, context?: HttpContext): Observable<StrictHttpResponse<ReprogramarFechaModelDto>> {
  const rb = new RequestBuilder(rootUrl, citasControllerReprogramarCita.PATH, 'post');
  if (params) {
    rb.path('uuidCita', params.uuidCita, {});
    rb.query('tipoConsulta', params.tipoConsulta, {});
    rb.query('tipoCita', params.tipoCita, {});
    rb.query('nuevaRangoCitaInicio', params.nuevaRangoCitaInicio, {});
    rb.query('nuevaRangoCitaFin', params.nuevaRangoCitaFin, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReprogramarFechaModelDto>;
    })
  );
}

citasControllerReprogramarCita.PATH = '/api/citas/reprogramar-cita/{uuidCita}';
